import React from 'react';

import Router, { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import Style from './JDCard.module.css';

import { Button, Loader } from '../../atoms';

import { isEmpty } from '../../../utils/generic';
import { pushEventInLoggy } from '../../../utils/loggy';

function JobDescriptionCard({ showModal }) {
  const currentUser = useSelector((state) => state.currentUser);
  const { my_profile } = useSelector((state) => state);
  const router = useRouter();
  const fullPathname = router?.asPath;

  const handleApply = () => {
    pushEventInLoggy(
      {
        event: 'Apply_Now_Browse_Job',
        page_name: 'Browse Job'
      },
      my_profile
    );

    if (currentUser?.data) {
      showModal();
    } else {
      sessionStorage.setItem('redirect_url', fullPathname);
      sessionStorage.setItem('jobId', job_details?.data?.data?.id);
      Router.push('/login');
    }
  };

  const handleRefer = () => {
    pushEventInLoggy(
      {
        event: 'Reffer_Friend_Browse_Job',
        page_name: 'Browse Job - Job Details'
      },
      my_profile
    );
    Router.push('/refer');
  };

  const { job_details } = useSelector((state) => state);
  const isJobApplied = job_details?.data?.data?.job_application ? true : false;
  const descriptionData = job_details?.data?.data?.job_description;
  const duration_of_engagement = job_details?.data?.data?.duration_of_engagement_in_months;

  const experience =
    job_details?.data?.data?.required_experience_min && job_details?.data?.data?.required_experience_max
      ? job_details?.data?.data?.required_experience_min == job_details?.data?.data?.required_experience_max
        ? `${job_details?.data?.data?.required_experience_min}+ Years Experience`
        : `${job_details?.data?.data?.required_experience_min} - ${job_details?.data?.data?.required_experience_max} Years Experience`
      : '--';

  const salary = job_details?.data?.data?.candidate_rate_monthly_text ? job_details?.data?.data?.candidate_rate_monthly_text : '--';

  const navigateToJobsPage = () => {
    router.push({
      pathname: `/jobs/${job_details?.data?.data?.id}`,
      query: { prevPage: router?.asPath }
    });
  };

  return (
    <>
      {job_details?.data?.data ? (
        <div className={Style.jobDescriptionOuterDiv}>
          <div className={Style.jobDescriptionHeader}>
            <div className='align-bottom'>
              <div className={Style.JobCardTitle} onClick={navigateToJobsPage}>
                {job_details?.data?.data?.job_role_name ? job_details?.data?.data?.job_role_name : job_details?.data?.data?.posting_title}
              </div>
              {job_details?.data?.data?.display_sourcing_partner_name ? (
                <div className='ml-auto'>
                  <span className='font-italic font-12px'>Posted by {job_details?.data?.data?.sourcing_partner_name}</span>
                </div>
              ) : null}
            </div>
            {job_details?.data?.data?.display_client_name && job_details?.data?.data?.client_name ? (
              <div className='font-16px mt-2'>{`${job_details?.data?.data?.client_name}`}</div>
            ) : null}
            <div className='margin-0 flexStyleStart'>
              {/* {(job_details.job_tags.includes('Urgent') || job_details.job_tags.includes('urgent')) ? <div className={`${Style.JobCardUrgent}`}>Urgent</div> : <></>}
          {job_details.contractual ? <div className={` ${Style.JobCardContract}`}>Contractual</div> : <></>} */}
              {job_details?.data?.data?.job_tags?.map((item, index) => (
                <div className={item === 'urgent' || item === 'Urgent' ? ` ${Style.JobCardUrgent}` : `${Style.JobCardContract}`} key={index}>
                  {item}
                </div>
              ))}
              {/* <div className={` ${Style.JobCardCopy} ${Style.JobCardCopy1}`}>Copy 1</div>
          <div className={` ${Style.JobCardCopy} ${Style.JobCardCopy2}`}>Copy 2</div>
          <div className={` ${Style.JobCardCopy} ${Style.JobCardCopy3}`}>Copy 3</div> */}
            </div>
            <div className='flexStyleStart padding16T'>
              <div className={`${Style.JobCardExpAndSalary}`}>
                <img className={Style.JobCardImages} src='/images/job-dashboard/briefcase-outline.svg' />
                <div className={Style.JobCardText}>{experience}</div>
              </div>
              <div className={`${Style.JobCardLine}`} />
              <div className={`${Style.JobCardExpAndSalary}`}>
                <img className={Style.JobCardImages} src='/images/job-dashboard/currency_rupee.svg' />
                <div className={Style.JobCardText}>{salary}</div>
              </div>
              {!isEmpty(duration_of_engagement) ? (
                <>
                  <div className={`${Style.JobCardLine}`} />
                  <div className={`${Style.JobCardExpAndSalary}`}>
                    <img className={`${Style.JobCardImages} m-r-8`} src='/images/job-dashboard/duration.png' />
                    {duration_of_engagement == 1 ? `1 Month` : `${duration_of_engagement} Months`}
                  </div>
                </>
              ) : null}
            </div>
            <div className={`row margin-0 ${Style.JobCardExpAndSalary}`}>
              <div className='col-6 flexStyleStart flexWrap padding0'>
                <img className={Style.JobCardImagesAuto} src='/images/job-dashboard/map-marker-outline.svg' />
                {job_details?.data?.data?.locations?.map((location, i) => (
                  <div className={Style.JobCardText} key={i}>
                    {location?.city + (i === job_details?.data?.data?.locations.length - 1 ? '' : ', ')}
                  </div>
                ))}
              </div>
              <div className='col-6 padding0'>
                <div className='flexStyleEnd'>
                  <Button className='general-style-refer center-y' onClick={handleRefer}>
                    Refer a friend <img className={Style.JobCardArrowBtn} height={24} src='/images/job-dashboard/arrow-right.svg' width={24} />
                  </Button>
                  {!isJobApplied ? (
                    <Button className='general-style' data-testid='apply-now' onClick={handleApply}>
                      Apply Now
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className='padding16B'>
            <div className={` ${Style.descScrollableSection} padding32 padding0B`}>
              <div className='bold mb-3'>
                Job Id: <span className='font-14px'>{job_details?.data?.data?.role_code}</span>
              </div>
              {/* <div className={Style.jobDescriptionTitle}>Job Description</div> */}
              {/* <div className={Style.jobDescriptionText}>{job_details?.data?.data?.job_description}</div> */}
              <div className='global-font-family' dangerouslySetInnerHTML={{ __html: descriptionData }} />
            </div>
          </div>
        </div>
      ) : job_details?.isFetching ? (
        <div className='center-x-y p-t-b-100'>
          <Loader size='lg' type='text-light' />
        </div>
      ) : null}
    </>
  );
}

export default JobDescriptionCard;
